import styled from "styled-components";
import {FaLocationDot, FaPhone} from "react-icons/fa6";
import {MdEmail} from "react-icons/md";

const StyledFooter = styled.div`
    display: block;
    width: 100%;
    height: 350px;
    background-color: #35644c;
    margin-top: -25px;
    margin-bottom: -25px;
    position: relative;
    padding-top: 250px;
    @media (max-width: 800px) {
        margin-top: 50px;
        padding-top: 250px;
    }
`;

const Logo = styled.img`
    width: 7%;
    margin-top: 60px;
    margin-left: 15%;
`;

const StyledFooterParagraph = styled.p`
    color: #ffffea;
    font-family: "Roboto", "serif";
    font-size: 16px;
    font-weight: 400;
    padding-bottom: 0;
    margin-left: 15%;
    width: 100%;
`;

const StyledFooterSpan = styled.span`
    color: #ffffea;
    font-family: "Roboto", "serif";
    font-size: 18px;
    font-weight: 700;
`;

const StyledFooterContactParagraph = styled.p`
    color: #ffffea;
    font-family: "Roboto", "serif";
    font-size: 14px;
    font-weight: 400;
    float: right;
`;


const StyledMap = styled.iframe`
    width: 100%;
    height: 220px;
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
    //border-radius: 25px;
    z-index: 10;
    @media (max-width: 800px) {
        top: 0;
        left: 0;
        width: 100%;
    }
`;

const StyledCopyright = styled.div`
    width: 100%;
    text-align: center;
    color: #ffffea;
    font-family: "Roboto", "serif";
    font-size: 12px;
    position: absolute;
    bottom: 50px;
`;


function Footer() {
    return (
        <StyledFooter>
            {/*<Logo src={logo} alt="EPDM Trading logo"/>*/}
            <StyledFooterParagraph>
                <StyledFooterSpan>
                    ИПИДИЕМ ТРЕЙДИНГ БЪЛГАРИЯ ЕООД
                </StyledFooterSpan>
            </StyledFooterParagraph>
            <StyledFooterParagraph>
                <FaLocationDot/> Ул. Малобучински Път 65, София
            </StyledFooterParagraph>
            <StyledFooterParagraph>
                <MdEmail/> office@epdm.bg
            </StyledFooterParagraph>
            <StyledFooterParagraph>
                <FaPhone/> +359 888 751 443
            </StyledFooterParagraph>
            <StyledMap
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2932.2066909850337!2d23.19453037649496!3d42.69934407116335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa9bcb346357bd%3A0x50e0c990cffa40ec!2z0LwuINCc0LDQvdC40LvQvtCyINC00L7QuywgdWwuICJNYWxvYnVjaGluc2tpIHBhdCIgNjUsIDEzOTAgSXZhbnlhbmU!5e0!3m2!1sen!2sbg!4v1751794615452!5m2!1sen!2sbg"
                width="1200" height="300" allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">

            </StyledMap>
            <StyledCopyright>
                Copywrignt 2025 - EPDM Trading Bulgaria
            </StyledCopyright>
        </StyledFooter>
    );
}

export default Footer;
